import React from 'react';
import { ImagesProvider } from 'contexts/ImagesContext';
import ButtonCopy from 'components/fragments/ButtonCopy/ButtonCopy';
const ButtonCopyComponent = (props) => (
  <ImagesProvider
    intro={false}
    r={require.context(
      'components/fragments/ButtonCopy/',
      true,
      /\.(png|jpe?g|svg|gif)$/
    )}
  >
    <ButtonCopy {...props} />
  </ImagesProvider>
);

export default ButtonCopyComponent;
